export default __webpack_public_path__ + "static/media/fire-icon.c3620094.svg";